import React, { useEffect, useState, useContext } from 'react'

import { useParams } from 'react-router-dom'
import axios from 'axios'

import { UserContext, SettingsContext } from '../contexts/index.jsx'
import { Loading, Alert } from "../components"
import { queryParam } from '../core/utils/queryParam.js'

const Verification = ({ children, onSubmit }) => {
    const userContext = useContext(UserContext)
    const { isRetailCircle } = useContext(SettingsContext);
    const [called, setCalled] = useState(false);

    let { code } = useParams();

    if (isRetailCircle) {
      code = queryParam('daotoken', window.parentQueryParams);
    }

    const [ status, setStatus ] = useState(code ? 'submitting' : 'error')

    useEffect(() => {
        if (!code || called) {
          return;
        }

        async function fetchData() {
            setCalled(true);
            try {
                const { data } = await axios.post(`/api/email-verifications/${code}/verify`)
                setStatus('success')
                userContext.refresh()

                onSubmit && onSubmit(data)
            } catch (error) {
                setStatus("error")
            }
        }

        fetchData()
    }, [code])

    if (status === 'submitting') {
        return <Loading type="loading" text="Verifying..." />
    }

    if (status === 'error') {
        return <Alert message="Verification failed!" description="The link is invalid or expired." />
    }

    if (status === 'success') {
        return <>{children}</>
    }
};

export default Verification
